import { render, staticRenderFns } from "./IconExchange.vue?vue&type=template&id=6501071b&"
import script from "./IconExchange.vue?vue&type=script&lang=ts&"
export * from "./IconExchange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports